import React, { useContext, useEffect, useState } from "react";
import {
  Input,
  SignInWithGoogle,
  ToastError,
  ToastSuccess,
} from "../global/component";
import { Link, useNavigate } from "react-router";
import { LoginService } from "../models/ApiService";
import FreeTips from "./FreeTips";
import AuthContext from "../global/auth-context";
import { ToastContainer } from "react-toastify";
import Slider from "../components/Slider";
import { Analytics } from "@vercel/analytics/react";
import HeaderNav from "../components/HeaderNav";
import { GrGoogle, GrGooglePlus } from "react-icons/gr";

const Login = () => {
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [errors, setErrors] = useState({});
  const [isError, setIsError] = useState(true);
  const [isFormValid, setIsFormValid] = useState(false);
  const [hide, setHide] = useState(true);
  const [select, setSelect] = useState(false);
  const [submit, setSubmit] = useState(false);

  let { freeTips, login, fetchUserData } = useContext(AuthContext);
  let navigate = useNavigate();

  const validateForm = () => {
    let errors = {};

    // Validate email field
    if (!email) {
      errors.email = "Email is required.";
    } else if (!/@\S+\.\S+/.test(email)) {
      errors.email = "Email is invalid.";
    }

    // Validate password field
    if (!password) {
      errors.password = "password is required.";
    } else if (password.length < 6) {
      errors.password = "Password must be at least 6 characters.";
    }

    // Set the errors and update form validity
    setErrors(errors);
    setIsFormValid(Object.keys(errors).length === 0);
  };

  useEffect(() => {
    validateForm();
  }, [email, password]);

  async function LoginFunction(paerams) {
    if (isFormValid) {
      let payload = { email, password };
      let response = await LoginService(payload);
      if (response.success == true) {
        ToastSuccess(response.message);
        login(email.toLowerCase());
        fetchUserData(email.toLowerCase());

        console.log(response);
        return navigate("/");
      } else {
        ToastError(response.message);
      }
    } else {
      ToastError("form has errors, please correct them");
    }
  }

  return (
    <>
      <Analytics />
      {/* <ToastContainer /> */}
      <HeaderNav />
      <div className="bg-myLightGreen  px-5  flex py-10 overflow-y-auto flex-col md:flex-row md:justify-center md:gap-20">
        <div className="w-full flex flex-col md:w-1/2 gap-10 ">
          <text className="font-bold text-xl md:text-2xl text-myNormalGreen">
            Welcome Back,
          </text>
          <div className="flex gap-5 flex-col ">
            <div className="flex w-full  flex-col h-fit">
              <input
                className="px-5 h-12 rounded-full border-2 border-myNormalGreen outline-none"
                placeholder={"Email"}
                type={"email"}
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <text className="text-red-500 px-5">{errors.email}</text>
            </div>
            <div className="flex w-full  flex-col h-fit">
              <input
                className="px-5 h-12 rounded-full border-2 border-myNormalGreen outline-none"
                placeholder={"Password"}
                type={"password"}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
              <text className="text-red-500 px-5">{errors.password}</text>
            </div>

            <div>
              <a
                href="/forgot-password"
                className="text-myNormalGreen float-end text-end -mt-3 px-3 font-medium w-fit"
              >
                forgot password?
              </a>
            </div>
          </div>
          <Link
            onClick={LoginFunction}
            className="md:py-2 self-center bg-myNormalGreen py-1 text-white font-bold text-lg w-full text-center rounded-xl"
          >
            Login
          </Link>
          <text className="-mt-3 px-3 font-medium text-center md:text-2xl ">
            Don't have an account?{" "}
            <a href="/register" className="text-myNormalGreen">
              Create Account
            </a>
          </text>
        </div>
        <div className="border-[1px] border-b-black mb-5 mt-10 -mx-5 md:hidden" />

        <div className="flex justify-center items-center  flex-col gap-5 md:w-1/3">
          <text>Or Continue with</text>
          <SignInWithGoogle navigate={navigate} />
        </div>
      </div>
    </>
  );
};

export default Login;
